import './VarLibrary.scss';
export class VarLibraryController {
    static $inject = ['close', 'userVariables', 'defaultVariables', '$translate', '$rootScope'];
    constructor(close, userVariables, defaultVariables, $translate, $rootScope) {
        'ngInject';
        this.close = close;
        this.userVariables = userVariables;
        this.defaultVariables = defaultVariables;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.onSearchUserChange = ({ detail: { value } }) => {
            this.searchUser = value;
            this.$rootScope.$apply();
        };
        this.onSearchDefaultChange = ({ detail: { value } }) => {
            this.searchDefault = value;
            this.$rootScope.$apply();
        };
        this.onMouseEnter = (e) => {
            const parentElement = this.getParentElement(e.target);
            const tooltip = parentElement.querySelector('bds-tooltip');
            tooltip.style.opacity = '1';
        };
        this.onMouseLeave = (e) => {
            const parentElement = this.getParentElement(e.target);
            const tooltip = parentElement.querySelector('bds-tooltip');
            tooltip.style.opacity = '0';
        };
        this.init();
    }
    async init() {
        this.copyText = await this.$translate('varLibrary.copyText');
    }
    async copyToClipboard(event) {
        const varSpan = event.target.parentNode.parentNode.parentNode.querySelector('.value-in-variable-library');
        const range = document.createRange();
        range.selectNodeContents(varSpan);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        const hasCopied = document.execCommand('copy');
        if (hasCopied) {
            selection.removeAllRanges();
            this.copyText = await this.$translate('varLibrary.copiedText');
            setTimeout(async () => {
                this.copyText = await this.$translate('varLibrary.copyText');
            }, 1000);
        }
    }
    getParentElement(element) {
        return element.hasAttribute('ng-repeat') ? element : element.parentElement;
    }
}
VarLibraryController.$inject = ['close', 'userVariables', 'defaultVariables', '$translate', '$rootScope'];
